<script lang="ts">
  import { type PageLayoutProps } from './PageLayout.vue'
  export interface PageLayoutPresetTabsProps extends PageLayoutProps {
    tabs: TabItem[]
  }
</script>
<script setup lang="ts">
  import PageLayout from './PageLayout.vue'
  import { GatTab, type TabItem } from '@gat-ship/vue-components'

  const props = withDefaults(defineProps<PageLayoutPresetTabsProps>(), {})
</script>
<template>
  <PageLayout v-bind="props">
    <template #actions>
      <slot name="actions" />
    </template>
    <div v-if="props.tabs.length > 0" class="flex flex-row items-center gap-2">
      <gat-tab :tabs="props.tabs" mode="route" />
      <slot name="append-tabs" />
    </div>
    <slot />
  </PageLayout>
</template>
